import React, { useState } from 'react'

import './custom-user.scss'
import miscUtils from 'utils/miscUtils'
import MiniProfile from 'components/userComponent/MiniProfile'
import { RoleIds } from 'containers/teamsContainer/domain'
import { activeMemberIDAtom, memberDetailsProfilePopupAtom } from 'showMessageMenuAtom'
import { useAtom } from 'jotai'

const CustomUserComponent = ({
    user,
    group,
    rightPlacement = true,
    isHost = undefined,
    miniProfileLeftPlacement,
    profileImageStyles,
    disableMiniProfile = false,
    badge = undefined,
}: {
    user: any,
    group: any,
    rightPlacement?:
    boolean, isHost?: any,
    miniProfileLeftPlacement?: any
    profileImageStyles?: any
    disableMiniProfile?: boolean
    badge?: any
}
) => {
    const [miniProfile, setShowMiniProfile] = useState(false)
    const [, setActiveMemberID] = useAtom(activeMemberIDAtom);

    const memberID = user && user.user && user.user.id

    const OpenMiniProfile = () => {
        if (!miscUtils.isGroupMember(group && group) || disableMiniProfile) return
        if (rightPlacement) setShowMiniProfile(true)
    }

    const determinePrivilege = () => {
        if (isHost) {
            return isHost;
        } else if (user && user.role_label && user.role_label.label) {
            return user.role_label.label.name
        } else if (user && user.user_role_label) {
            return user.user_role_label
        } else if (user && user.user && user.user.user_role_label) {
            return user.user.user_role_label
        } else if (user && user.role_id) {
            switch (user.role_id) {
                case RoleIds.Owner:
                    return "Owner";
                case RoleIds.Admin:
                    return "Admin";
                case RoleIds.Moderator:
                    return "Moderator";
                default:
                    return "Member";
            }
        } else if (user && user.user_role_id) {
            switch (user.user_role_id) {
                case RoleIds.Owner:
                    return "Owner";
                case RoleIds.Admin:
                    return "Admin";
                case RoleIds.Moderator:
                    return "Moderator";
                default:
                    return "Member";
            }
        } else {
            switch (user && user.user.role_id) {
                case RoleIds.Owner:
                    return "Owner";
                case RoleIds.Admin:
                    return "Admin";
                case RoleIds.Moderator:
                    return "Moderator";
                default:
                    return "Member";
            }

        }
    }

    const [, setOpenmemberDetailsProfilePopup] = useAtom(memberDetailsProfilePopupAtom);

    const openPeopleDialog = () => {
        setOpenmemberDetailsProfilePopup(true)
    }

    const openProfileSlider = () => {
        setActiveMemberID(memberID)
        openPeopleDialog()
    }

    const [isValidImage, setIsValidImage] = React.useState(true);
    const onImageError = (e: any) => {
        setIsValidImage(false)
    }

    return (
        <div className='custom-user'>
            <div
                className='header'
                onMouseEnter={() => { OpenMiniProfile() }}
                onMouseLeave={() => setShowMiniProfile(false)}
            >
                {
                    (user.user.profile_image && isValidImage)
                        ?
                        <div className={`member-profile-img ${profileImageStyles}`}>
                            <img
                                className={`member-profile-img`}
                                alt='user profile'
                                src={user.user.profile_image}
                                onError={onImageError}
                            />
                        </div>
                        :
                        <>
                            {
                                user.user.full_name !== null ?
                                    <div
                                        className={`member-profile-img ${profileImageStyles}`}
                                        data-color={miscUtils.getColorInitial(`${user.user.full_name}`)}

                                    >
                                        {miscUtils.getNameInitials(user.user.full_name)}
                                    </div>
                                    :
                                    <div
                                        className={`member-profile-img`}
                                        data-color={miscUtils.getColorInitial('No name')}

                                    >
                                        {miscUtils.getNameInitials('No name')}
                                    </div>
                            }
                        </>
                }
            </div>

            <div className='right'>
                {
                    user.user.full_name !== null ?
                        <span
                            className='name'
                            onClick={() => OpenMiniProfile()}
                        >
                            {user && user.user.full_name}
                            {badge ? (
                                <>
                                {badge}
                                </>
                            ) : <></>}
                        </span>
                        :
                        <span
                            className='name'
                            onClick={() => OpenMiniProfile()}
                        >
                            No name
                            {badge ? (
                                <>
                                {badge}
                                </>
                            ) : <></>}
                        </span>
                }
                {
                    !isHost &&
                    <span className='email'>{user && user.user.email}</span>
                }
                {
                    isHost && <span className='email'>{isHost}</span>
                }
            </div>

            {
                miniProfile &&
                <MiniProfile
                    fullName={user && user.user.full_name}
                    setShowMiniProfile={setShowMiniProfile}
                    ProfileImage={user && user.user.profile_image}
                    determinePrivilege={determinePrivilege}
                    openProfileSlider={openProfileSlider}
                    miniProfileLeftPlacement={miniProfileLeftPlacement}
                />
            }
        </div>
    )
}

export default CustomUserComponent